<template>
  <v-row no-gutters justify-space-between align-center row>
    <v-col sm="12" px-0 class="pt-0">
      <v-row no-gutters>
        <v-col sm="8" class="email-data" id="email-data" v-if="archiveDetails">
          <!-- v-html="archiveDetails.body" -->
          <div class="data-tag" id="mailContent">
            <iframe
              id="contentBox"
              height="100%"
              width="100%"
              style="border:0;"
              data-test-id="email__iframe"
            ></iframe>
          </div>
          <div class="data-actions" v-if="hideOnArchive">
            <button
              v-if="
                projectStatus !==
                  $enums.projectStatus.ARCHIVED
              "
              class="addIcon"
              color="#d8d8d8"
              data-test-id="add-annotation-btn"
              :class="{ 'scale-up-center': animateIcon }"
              @click="showButton"
            >
              <v-icon>add</v-icon>
            </button>
            <div class="addChild" v-if="showAction">
              <v-btn
                small
                color="#7440fb"
                class="white--text"
                data-test-id="tag-annotation-btn"
                @click="addTag"
                >
                Create a tag
              </v-btn>
              <v-btn
                small
                color="#58e2c2"
                class="mt-1 white--text"
                data-test-id="comment-annotation-btn"
                @click="addComment"
              >
                Add a comment
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col v-else>
          <v-skeleton-loader
            type="paragraph@2"
            class="mb-2"
            :loading="true"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="card"
            class="mb-2"
            :loading="true"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="paragraph@3"
            class="mb-2"
            :loading="true"
          ></v-skeleton-loader>
        </v-col>
        <v-col sm="4" class="inputsData">
          <div class="labelForInput pr-0 ml-9 py-3 pt-0">
            <div class="stripIndicator tags"></div>
            <div class="textIndicator">Tags are marked in purple</div>
          </div>
          <div class="labelForInput pr-0 ml-9 py-3">
            <div class="stripIndicator comment"></div>
            <div class="textIndicator">Comments are marked in green</div>
          </div>

          <div class="pr-0 ml-9">
            <!-- for adding a new tag in RHS-->
            <TagBox
              :key="tagKey"
              v-if="path === 'tag'"
              :allUserObj="allUserObj"
              :archiveId="selectedArchiveId"
              :objSelection="objSelectionHelper"
              :tagContent="tagContent"
              :displayOnly="displayOnly"
              :projectStatus="projectStatus"
              @closeTagBox="closeTagBox"
              @refreshAllComments="refreshAllComments"
            />
            <!-- this is for all the comments in RHS -->
            <CommentPanel
              v-if="path === 'comment'"
              :archiveId="selectedArchiveId"
              :projectStatus="projectStatus"
              :objSelection="objSelectionHelper"
              :selectedComments="selectedCommentsCpy"
              @refreshAllComments="refreshAllComments"
            />
          </div>
        </v-col>
      </v-row>
      <v-row justify-end align-content-center pt-5 v-if="false">
        <x-button
          color="#58e2c2"
          :clickFunction="backToOverviewForSaved"
          buttonText="Back"
        />
        <x-button
          color="#58e2c2"
          :clickFunction="backToOverviewForSaved"
          buttonText="Next"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import EventBus from '@/EventBus';
import TagBox from './TagBox';
import CommentPanel from './CommentPanel';
import CommentService from '@/services/CommentService';
import SelectionHelper from '@/helpers/SelectionHelper';
import XPathHelper from '@/helpers/XPathHelper';
import { mapState } from 'vuex';
export default {
  components: { TagBox, CommentPanel },
  props: ['archiveDetails', 'loading', 'selectedArchiveId', 'allUserObj'],
  data() {
    return {
      path: null,
      tagKey: 0,
      animateIcon: false,
      // will be used to scroll to last scroll position before adding a comment or tag
      nodesCurrentlyInSelection: [],
      allCommentsAndTags: [],
      selectedComments: [],
      selectedCommentsCpy: [],
      selectedTags: [],
      displayOnly: false,
      tagContent: null,
      objSelectionHelper: null,
      showAction: false,
      selectedText: '',
      tagData: null,
      commentData: null,
      hideOnArchive: true
    };
  },
  computed: {
    ...mapState(['projectDetails']),
    projectStatus() {
      return this.projectDetails?.projectStatus || '';
    }
  },
  created() {
    this.objSelectionHelper = new SelectionHelper(true);
  },
  mounted() {
    this.heightpane = this.setheight;
    EventBus.$on('EMAIL_PROCESS_COMMENT_TAG', () => {
      this.processCommentsAngTags();
    });
    EventBus.$on('SHOW_ACTION_BUTTON', val => {
      this.showAction = val;
    });

    EventBus.$on('COMMENT_CLICKED', commentId => {
      this.showAction = false;
      this.path = 'comment';
      // needed so that it could wait for DOM update
      this.$nextTick(() => {
        this.openExistingComment(commentId);
      });
    });

    EventBus.$on('TAG_CLICKED', tagId => {
      this.showAction = false;
      this.displayOnly = false;
      this.tagContent = null;
      this.tagKey = tagId;
      let tagContent = this.selectedTags.find(tag => tag.id === tagId);
      if (tagContent) {
        this.displayOnly = true;
        this.tagContent = tagContent;
      }
      this.path = 'tag';
    });

    EventBus.$on('COMMENT_DELETED', commentId => {
      this.path = '';
      let selectedCommentsCpy = this.selectedCommentsCpy.filter(comment => {
        return comment.id !== commentId;
      });
      this.$set(this.selectedCommentsCpy, selectedCommentsCpy);
      this.$nextTick(() => {
        this.path = 'comment';
      });
    });

    EventBus.$on('TAG_DELETED', tagId => {
      this.path = '';
      let selectedTagsCpy = this.selectedTags.filter(tag => {
        return tag.id !== tagId;
      });
      this.$set(this.selectedTags, selectedTagsCpy);
      this.$nextTick(() => {
        this.path = '';
      });
    });

    if (
      this.projectStatus ===
      this.$enums.projectStatus.ARCHIVED
    ) {
      this.hideOnArchive = false;
    }
  },

  methods: {
    removeCommentSelection(commentOrTag, id) {
      const searchFor =
        commentOrTag === 'comment' ? '.userComment' : '.userTag';
      const contentBoxFrame = document.getElementById('contentBox');
      const contentBoxBody = contentBoxFrame.contentWindow.document.body;
      const highlightedSelections = contentBoxBody.querySelectorAll(searchFor);
      highlightedSelections.forEach(function(highlightedSelection) {
        if (highlightedSelection.dataset.comment === id) {
          // jQuery(this).replaceWith(jQuery(this).html());
        }
      });
    },
    selectComment(annotation) {
      let style = null;
      let className = null;
      if (annotation.type === 'COMMENT') {
        style =
          'style="background:#58e2c2;box-shadow:0 2px 2px #ccc;cursor:pointer;"';
        className = 'userComment';
      } else if (annotation.type === 'TAG') {
        style =
          'style="background:#7440FB;box-shadow:0 2px 2px #ccc;cursor:pointer;"';
        className = 'userTag';
      } else {
        return;
      }
      let comment = annotation.annotation;
      // !IMPORTANT: This section needs cleanup. Please ignore for now.
      try {
        let startContainer = XPathHelper.getElementByXpath(
          document.getElementById('contentBox').contentWindow.document,
          comment.startPoint
        );
        let endContainer = XPathHelper.getElementByXpath(
          document.getElementById('contentBox').contentWindow.document,
          comment.endPoint
        );
        let range = document.createRange();
        range.setStart(startContainer, 0);
        range.setEnd(endContainer, 0);

        let nodesInRange = this.objSelectionHelper.getNodesInRange(range);
        let startDone = false;
        let startOffset = comment.startIndex;
        let endOffset = comment.endIndex;
        let textFound = false;
        nodesInRange.forEach(element => {
          if (element.nodeName === '#text') {
            textFound = true;

            let textContent = element.textContent;
            let part1 = textContent;
            let part2 = '';
            if (element.isSameNode(startContainer)) {
              // this is start
              if (!startDone) {
                part1 = textContent.slice(0, startOffset);
                part2 =
                  '<mark class="' +
                  className +
                  '" data-comment="' +
                  comment.id +
                  '" ' +
                  '" data-test-id="' +
                  comment.id +
                  '" ' +
                  style +
                  '>' +
                  textContent.slice(startOffset) +
                  '</mark>';
                startDone = true;
              } else {
                part1 =
                  '<mark class="' +
                  className +
                  '" data-comment="' +
                  comment.id +
                  '" ' +
                  '" data-test-id="' +
                  comment.id +
                  '" ' +
                  style +
                  '>' +
                  textContent.substr(0, endOffset) +
                  '</mark>';
                part2 = textContent.substr(endOffset);
              }
            } else if (element.isSameNode(endContainer)) {
              // this is end
              part1 =
                '<mark class="' +
                className +
                '" data-comment="' +
                comment.id +
                '" ' +
                '" data-test-id="' +
                comment.id +
                '" ' +
                style +
                '>' +
                textContent.substr(0, endOffset) +
                '</mark>';
              part2 = textContent.substr(endOffset);
            } else {
              // these are all others
              part1 =
                '<mark class="' +
                className +
                '" data-comment="' +
                comment.id +
                '" ' +
                '" data-test-id="' +
                comment.id +
                '" ' +
                style +
                '>' +
                part1 +
                '</mark>';
            }
            let highlightSpan = document.createElement('span');
            highlightSpan.setAttribute('class', 'marker');
            highlightSpan.innerHTML = part1 + part2;
            element.parentNode.replaceChild(highlightSpan, element);
          }
        });
        if (!textFound) {
          // eslint-disable-next-line
          if (range.startContainer == range.endContainer) {
            let part1 = range.startContainer.textContent.slice(0, startOffset);
            let part2 =
              '<mark class="' +
              className +
              '" data-comment="' +
              comment.id +
              '" ' +
              '" data-test-id="' +
              comment.id +
              '" ' +
              style +
              '>' +
              range.startContainer.textContent.slice(startOffset, endOffset) +
              '</mark>';
            let part3 = range.startContainer.textContent.slice(endOffset);
            let div = document.createElement('span');
            div.innerHTML = part1 + part2 + part3;
            range.startContainer.parentNode.replaceChild(
              div,
              range.startContainer
            );
          }
        }
        // eslint-disable-next-line
      } catch (err) {}
      this.$nextTick(() => {
        if (this.allCommentsAndTags.length) {
          let annotation = this.allCommentsAndTags.pop();
          this.selectComment(annotation);
        } else {
          // add event handlers once all is done
          this.addEventHandlersForCommentsTags();
        }
      });
    },
    // selects pre selected comments and tags on page
    makeSelections() {
      this.eventSelectionCommentsTags();
      if (!this.allCommentsAndTags.length) {
        return;
      }
      let annotation = this.allCommentsAndTags.pop();
      this.selectComment(annotation);
    },
    async getCommentsAndTags() {
      let commentsAndTags = await CommentService.loadCommentsForArchive(
        this.$route.params.projectId,
        this.selectedArchiveId
      );

      if (commentsAndTags.data.success) {
        this.allCommentsAndTags = commentsAndTags.data.body.reverse();
        this.selectedComments = this.getElementsFromResponse(
          commentsAndTags.data.body,
          'COMMENT'
        );
        this.selectedCommentsCpy = [...this.selectedComments];
        this.selectedTags = this.getElementsFromResponse(
          commentsAndTags.data.body,
          'TAG'
        );
        this.makeSelections();
      }
    },
    processCommentsAngTags() {
      let doc = document.getElementById('contentBox').contentWindow.document;
      /*
        START RANT
          - Now this is where I get frustrated in 2020.
          - Apparently, firefox loads an 'about:blank' page by default when a frame is inserted. So, you set the innerHTML and then about:blank load completes - there goes the html you set earlier.
          - To overcome this simulate opening and closing a tab to finish any events.
          - Then set the innerHTML to whatever you want
        END RANT
      */
      doc.open();
      doc.close();

      doc.body.innerHTML = this.archiveDetails.body;

      this.getCommentsAndTags();
    },
    getElementsFromResponse(response, contentType) {
      return response
        .filter(element => element.type === contentType)
        .map(element => {
          return element.annotation;
        })
        .reverse();
    },
    eventSelectionCommentsTags() {
      const contentBoxFrame = document.getElementById('contentBox');
      const contentBoxFrameBody = contentBoxFrame.contentWindow.document.body;
      const self = this;
      contentBoxFrameBody.removeEventListener('mouseup', () => {});
      contentBoxFrameBody.addEventListener('mouseup', () => {
        if (self.isValidSelection()) {
          self.animateIcon = true;
        } else {
          self.animateIcon = false;
          self.showAction = false;
        }
      });
    },
    addEventHandlersForCommentsTags() {
      const contentBoxFrame = document.getElementById('contentBox');
      const contentBoxFrameBody = contentBoxFrame.contentWindow.document.body;
      this.modifyBodyClickEvents(contentBoxFrameBody, 'a');
      this.modifyBodyClickEvents(contentBoxFrameBody, '.userComment');
      this.modifyBodyClickEvents(contentBoxFrameBody, '.userTag');
    },
    closeTagBox() {
      this.path = null;
    },
    refreshAllComments() {
      // need to reset the iframe also
      // reload all comments and make selections because a new comment or tag has been added
      this.processCommentsAngTags();
    },
    isValidSelection() {
      return this.objSelectionHelper.getSelection('contentBox');
    },
    showButton() {
      this.path = null;
      this.showAction = false;
      this.animateIcon = false;
      if (this.isValidSelection()) {
        if (this.objSelectionHelper.isSelectionOverlapping()) {
          this.snackbar('error', this.$message.OVERLAPPING_SELECTION);
          return;
        }
        this.showAction = true;
        EventBus.$emit('OPEN_EXIST_COMMENT', false);
      } else {
        this.showAction = false;
        this.snackbar('error', this.$message.SELECT_CONTENT);
      }
    },
    clearSelection(selection) {
      selection.removeAllRanges();
      selection.empty();
    },
    goback() {
      this.$router.go(-1);
    },
    backToProject() {
      this.$router.push({
        path:
          '/discovery/projects/' + this.$route.params.projectId + '/archives'
      });
    },
    addTag() {
      this.showAction = false;
      this.animateIcon = false;
      if (!this.isValidSelection()) {
        this.snackbar('error', this.$message.SELECT_CONTENT);
        return;
      }
      if (this.objSelectionHelper.isSelectionOverlapping()) {
        this.snackbar('error', this.$message.OVERLAPPING_SELECTION);
        return;
      }
      this.scrollTo();
      this.tagKey = null;
      this.displayOnly = false;
      this.tagContent = null;
      this.path = 'tag';
    },
    addComment() {
      this.showAction = false;
      this.animateIcon = false;
      if (!this.isValidSelection()) {
        this.snackbar('error', this.$message.SELECT_CONTENT);
        return;
      }
      if (this.objSelectionHelper.isSelectionOverlapping()) {
        this.snackbar('error', this.$message.OVERLAPPING_SELECTION);
        return;
      }
      this.path = 'comment';
      this.$nextTick(() => {
        this.scrollTo();
        EventBus.$emit('COMMENT_BOX', true);
      });
    },
    openExistingTag() {
      EventBus.$emit('OPEN_EXIST_COMMENT', false);
      EventBus.$emit('OPEN_EXIST_TAG', true);
    },
    openExistingComment(commentId) {
      EventBus.$emit('OPEN_EXIST_TAG', false);
      EventBus.$emit('OPEN_EXIST_COMMENT', commentId);
    },
    modifyBodyClickEvents(contentBoxFrame, type) {
      const bodyAnchors = contentBoxFrame.querySelectorAll(type);

      bodyAnchors.forEach(bodyAnchorElement => {
        bodyAnchorElement.removeEventListener('click', () => {});
        bodyAnchorElement.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (type === 'a') {
            const href = bodyAnchorElement.href;
            if (href) {
              window.open(href);
            }
          } else if (type === '.userComment') {
            EventBus.$emit(
              'COMMENT_CLICKED',
              bodyAnchorElement.dataset.comment
            );
          } else if (type === '.userTag') {
            EventBus.$emit('TAG_CLICKED', bodyAnchorElement.dataset.comment);
          }
        });
      });
    },
    scrollTo() {
      const contentBoxFrame = document.getElementById('contentBox');
      const contentBox = contentBoxFrame.contentWindow.document.body;
      if ('scrollBehavior' in contentBox.style) {
        // If smooth scrolling is supported
        contentBox.scrollTo({
          top: contentBoxFrame.scrollTop,
          behavior: 'smooth'
        });
      } else {
        // Fallback for browsers that don't support smooth scrolling
        contentBox.scrollTop += 1;
      }
    }
  },
  beforeDestroy() {
    const contentBoxFrame = document.getElementById('contentBox');
    const contentBoxFrameBody = contentBoxFrame?.contentWindow?.document?.body;
    if (contentBoxFrameBody) {
      contentBoxFrameBody.removeEventListener('mouseup', () => {});
    }
    EventBus.$off('SHOW_ACTION_BUTTON');
    EventBus.$off('COMMENT_CLICKED');
    EventBus.$off('TAG_CLICKED');
    EventBus.$off('EMAIL_PROCESS_COMMENT_TAG');
  },
  watch: {
    selectedTab: function() {
      this.renderDocument();
    }
  }
};
</script>

<style>
.scale-up-center {
  -webkit-animation: scale-up-center 0.6s cubic-bezier(0.39, 0.575, 0.565, 1)
    infinite both;
  animation: scale-up-center 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) infinite
    both;
}

button.addIcon.scale-up-center {
  background: #58e2c2;
}

button.addIcon.scale-up-center i {
  color: #fff;
}
@keyframes scale-up-center {
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}

.archive-detail .v-btn {
  border-radius: 0;
}

.archive-detail .comment_desc {
  overflow-wrap: break-word;
}
.stripIndicator {
  width: 100%;
  height: 9px;
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
}
.tags,
.discovery_tag_bg {
  background-color: #7440fb;
}
.comment,
.discovery_comment_bg {
  background-color: #58e2c2;
}
.data-tag {
  padding: 40px;
  border: solid 1.5px #bfbfbf;
  overflow-y: hidden;
  height: 100%;
}
.email-data {
  position: relative;
  height: 100vh;
}

.tag_box .v-btn {
  border-radius: 0 !important;
}
.addIcon::before {
  border-radius: 50% !important;
  background-color: #d8d8d8;
  width: 38px;
  height: 38px;
}
.addIcon {
  background-color: #d8d8d8;
  width: 38px !important;
  height: 38px !important;
  border-radius: 50% !important;
}
.data-actions {
  position: absolute;
  top: 50%;
  right: -18px;
}
.addChild {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: calc(100% + 15px);
  top: calc(50% - 38px);
}
</style>
